import { BASE } from '@/config'

// Компоненты и роуты для роли
const DepartmentIndex = () => import('@/views/department/Index.vue')
const MainPageView = () => import('@/views/department/MainPageView.vue')
const ReportsView = () => import('@/views/department/ReportsView.vue')
const PassagesView = () => import('@/views/department/PassagesView')
const CardActionsView = () => import('@/views/department/CardActionsView')
const CardDeletedView = () => import('@/views/department/CardDeletedView')
const CardBlockedView = () => import('@/views/department/CardBlockedView')
const CardsView = () => import('@/views/department/CardsView')

export default {
  path: '/department',
  component: DepartmentIndex,
  meta: { role: BASE.ROLES.DEPARTMENT },
  children: [
    {
      path: '',
      name: 'MainPageDepartment',
      component: MainPageView,
      meta: { label: 'Главная' }
    },
    {
      path: 'cards',
      name: 'CardsDepartment',
      component: CardsView,
      meta: { label: 'Карты пользователей' }
    },
    {
      path: 'cards-blocked',
      name: 'CardBlockedDepartment',
      component: CardBlockedView,
      meta: { label: 'Блокированные карты' }
    },
    {
      path: 'cards-deleted',
      name: 'CardDeletedDepartment',
      component: CardDeletedView,
      meta: { label: 'Удаленные карты' }
    },
    {
      path: 'card-actions',
      name: 'CardActionsDepartment',
      component: CardActionsView,
      meta: { label: 'Реестр дейсвий с картой' }
    },
    {
      path: 'visits',
      name: 'PassagesDepartment',
      component: PassagesView,
      meta: { label: 'Проходы' }
    },
    {
      path: 'reports',
      name: 'ReportsViewDepartment',
      component: ReportsView,
      meta: { label: 'Отчёты' }
    }
  ]
};
